// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"7817e8374d56316adc2d","811":"6d74f7c176eaf7cdfab2"}[chunkId] + ".js");